/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import { useContext, useEffect } from 'react';
import axios from 'axios';
import { MyContext } from '../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import { showToast } from '../showTost';

const Midtrans = ({ Amount }) => {

    const { BaseUrl, setPaymentLoading } = useContext(MyContext);

    const handlePayment = async () => {

        const UserData = secureLocalStorage.getItem("Logindata");

        if (UserData) {
            const UserDetails = JSON.parse(UserData);
            await axios.post(`${BaseUrl}/react_midtrans/index.php`,
                {
                    "amt": Amount,
                    "name": UserDetails.name,
                    "email": `${UserDetails.name}@gmail.com`,
                    "phone": UserDetails.mobile
                }
            )
                .then((res) => {
                    console.log(res);

                    if (res.data.Result === "true") {
                        // window.location.href = res.data.payment_url;
                    } else {
                        showToast({ title: res.data.ResponseMsg, id: "error" });
                    }
                    setPaymentLoading(false);
                })
                .catch((error) => {
                    console.error("react_midtrans/index.php", error);
                });
        }
    };

    useEffect(() => {
        if (!Amount) return;
        handlePayment();
    }, [Amount]);

    return null;
};

export default Midtrans;
/* jshint ignore:end */